import { motion } from "framer-motion";
import { about, images } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", delay: i * 0.12 },
  }),
};

export const About = () => {
  return (
    <section
      id="chi-siamo"
      data-testid="about-section"
      className="relative bg-[#111111] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            {about.overline}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F5] tracking-tight leading-tight">
            {about.title}
          </h2>
          <div className="mt-6 space-y-4">
            {about.paragraphs.map((p, i) => (
              <p key={i} className="text-base text-gray-400 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
            {about.stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <p className="font-serif text-3xl lg:text-4xl text-[#D4AF37]">
                  {s.value}
                </p>
                <p className="mt-1 text-xs tracking-wide uppercase text-gray-500">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          variants={fadeUp}
          custom={1}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-2xl border border-[#D4AF37]/20">
            <img
              src={images.about}
              alt="Rreth Nesh — Bali Funeral Home"
              className="w-full h-[480px] object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="hidden lg:block absolute -bottom-6 -left-6 h-32 w-32 border border-[#D4AF37]/40 rounded-2xl -z-0" />
        </motion.div>
      </div>
    </section>
  );
};
